import { render, staticRenderFns } from "./ChannelBig.vue?vue&type=template&id=78bdac3c&"
import script from "./ChannelBig.vue?vue&type=script&lang=js&"
export * from "./ChannelBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports